import React from "react";

import Disclaimer from "../../../components/Disclaimer";
import PDFJSBackend from "../../../components/PDFViewer/pdfjs";
import PDFViewer from "../../../components/PDFViewer/PDFViewer";
import { useDocPrefix } from "../../../utils/common";

const Imprint: React.FC = () => {
  const docPrefix = useDocPrefix();
  const pdfLink = docPrefix + "imprint.pdf";

  return (
    <Disclaimer pdf={pdfLink}>
      <PDFViewer backend={PDFJSBackend} src={pdfLink} />
    </Disclaimer>
  );
};

export default Imprint;
